// extracted by mini-css-extract-plugin
export default {"container":"ActivityTemplates_container__27lfW"};